// extracted by mini-css-extract-plugin
export default {"protectedLayout":"ProtectedLayout_protectedLayout__byhGc","sidebarOpen":"ProtectedLayout_sidebarOpen__1F0X3","mainContent":"ProtectedLayout_mainContent__5CE1s"};